
import React from 'react';
import { Code2 } from 'lucide-react';
import SolutionCard from './cards/SolutionCard';

const CodingAgents = () => {
  return (
    <SolutionCard
      icon={Code2}
      title="Coding Agents"
      subtitle="AI-Powered Development"
      description="Enhance your development workflow with intelligent coding agents"
    >
      <div className="p-4 pb-1 mt-2 rounded-lg bg-secondary/30 hover:bg-secondary/50 transition-colors mb-0">
        <p className="text-muted-foreground">
          We work with you to build SOTA coding agents for specific use cases from writing SQL to building custom software for blockchain networks.
        </p>
      </div>
    </SolutionCard>
  );
};

export default CodingAgents;
